import { Link } from "react-router-dom";
import { DropdownMenuGroup, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { useTranslation } from "react-i18next";

interface UserDropdownItemsProps {
  referralLink: string;
}

const UserDropdownItems = ({ referralLink }: UserDropdownItemsProps) => {
  const { t } = useTranslation('common');
  const itemClassName = "rounded-md px-3 py-2.5 text-sm font-medium text-brand-ink focus:bg-brand-mist focus:text-brand-ink";
  
  return (
    <DropdownMenuGroup>
      <DropdownMenuItem className={itemClassName} asChild>
        <Link to="/profile">
          <span>{t("userMenu.profile")}</span>
        </Link>
      </DropdownMenuItem>
      <DropdownMenuItem className={itemClassName} asChild>
        <Link to="/user/listings">
          <span>{t("userMenu.myListings")}</span>
        </Link>
      </DropdownMenuItem>
      <DropdownMenuItem className={itemClassName} asChild>
        <Link to="/favorites">
          <span>{t("userMenu.favorites")}</span>
        </Link>
      </DropdownMenuItem>
      <DropdownMenuItem className={itemClassName} asChild>
        <a href={referralLink} target="_blank" rel="noopener noreferrer">
          <span>{t("userMenu.referFriend")}</span>
        </a>
      </DropdownMenuItem>
    </DropdownMenuGroup>
  );
};

export default UserDropdownItems;
